const Row = ({ label, value, mono = false }) =>
  value == null || value === "" ? null : (
    <div className="ui-kv__row">
      <span className="ui-kv__label">{label}</span>
      <span className={`ui-kv__value${mono ? " ui-kv__value--mono" : ""}`}>{value}</span>
    </div>
  );

export const CardShippingOrder = ({ order }) => {
  const isLocal = order?.delivery_type !== "DELIVERY";

  const hasSnapshot = !!order?.shipping_address;
  const s = hasSnapshot ? order.shipping_address : order.address_id;

  const country = hasSnapshot ? s?.country?.name : s?.country_id?.name;
  const department = hasSnapshot ? s?.province?.name : s?.province_id?.name;
  const city = hasSnapshot ? s?.city?.name : s?.city_id?.name;

  const address = s?.address;
  const name = s?.name;
  const postalCode = s?.postal_code;
  const observations = s?.observations;
  const tracking = order?.shipping?.tracking;
  const receiver = s?.receiver;

  return (
    <div className="ui-card">
      <div style={{ display: "flex", alignItems: "center", gap: 9, marginBottom: 15 }}>
        <i className="ri-truck-line" style={{ color: "#4B36F0", fontSize: 16 }} />
        <h3 style={{ margin: 0, fontSize: 15, fontWeight: 700 }}>Envío</h3>
      </div>

      {isLocal ? (
        <p style={{ margin: 0, color: "#8A91AE", fontSize: 12.5 }}>
          El usuario recogerá el pedido localmente.
        </p>
      ) : (
        <div className="ui-kv">
          <Row label="Número de guía de envío" value={tracking} mono />
          <Row label="País" value={country || "-"} />
          <Row label="Departamento" value={department || "-"} />
          <Row label="Ciudad" value={city || "-"} />
          <Row label="Nombre" value={name} />
          <Row label="Dirección" value={address || "-"} />
          <Row label="Recibe el pedido" value={receiver?.type === "other" ? "Otra persona" : "Titular"} />
          {receiver?.type === "other" && (
            <>
              <Row label="Nombre receptor" value={receiver?.name} />
              <Row label="Documento receptor" value={receiver?.document} mono />
              <Row label="Teléfono receptor" value={receiver?.phone} />
            </>
          )}
          <Row label="Código postal" value={postalCode || "-"} />
          <Row label="Observaciones" value={observations || "-"} />
          {order?.dropi && (
            <>
              <Row label="Transportadora" value={order.dropi.company} />
              <Row label="Número de guía" value={order.dropi.shipping_guide} mono />
            </>
          )}
        </div>
      )}
    </div>
  );
};
